module.exports = __webpack_public_path__ + "static/self-portrait_acrylic-on-cardboard-12x9in-2016-f9377bacb9aa794d52bc7297d329dd67.jpg";